import { createRestSlice } from "./restSlice";

export type Organization = {
  id: string;
  name: string;
  agentsEnabled: boolean;
  billingEnabled: boolean;
  outboundEnabled: boolean;
  agentCount: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

const organizationSlice = createRestSlice<Organization>("organization", "/v1/organizations");

export const organizationReducer = organizationSlice.reducer;
export const organizationActions = organizationSlice.actions;
